export const SUPPORTED_ERRORS = {
  host: __('Host'),
  templates: __('Templates'),
  proxies: __('Proxies'),
};
export const API_OPTIONS = { key: 'BUILD_REVIEW' };
